import { createUseStyles } from '../../theme/theming';

const useVideoTestimonialStyles = createUseStyles((theme) => {
  return {
    videoTestimonialSuperContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,

      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily
        // boxSizing: 'border-box'
      },
      '& h2,& h3,& p': {
        marginTop: '0'
      }
    },
    sectionContainer: {
      // margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    videoTestimonialContainer: {
      width: '100%',
      maxWidth: '1440px',
      fontFamily: theme?.typography?.fontFamily
    },

    videoTestimonialHeading: {
      fontSize: theme.typography.fontSize.subHead,
      lineHeight: '20px',
      letterSpacing: '3px',
      textTransform: 'uppercase',
      color: theme.palette.font.default,
      wordBreak: 'break-word'
      // marginBottom: '8px'
    },

    videoTestimonialTitle: {
      fontSize: theme.typography.fontSize.h2,
      // lineHeight: '71px',
      letterSpacing: '-3px',
      fontWeight: theme.typography.fontWeight.bold,
      marginBottom: theme.spacing.margin.tiny,
      color: theme.palette.font.default,
      wordBreak: 'break-word'
    },

    videoCarousel: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: '40px'
    },

    iframeSuperContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      // marginTop: '16px',
      borderRadius: '8px'
    },

    iframeContainer: {
      width: '100%',
      position: 'relative',
      paddingBottom: '56.25%'
    },

    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius.small
    },

    videoDetails: {
      width: '100%',
      display: 'flex',
      gap: '24px',
      flexDirection: 'column',
      alignItems: 'flex-start'
    },

    videoDetailsHeading: {
      fontSize: theme.typography.fontSize.h3,
      lineHeight: '48px',
      margin: '0',
      letterSpacing: '-1px',
      wordBreak: 'break-word',
      color: theme.palette.font.default,
      fontWeight: theme.typography.fontWeight.bold
    },

    videoDetailsContent: {
      fontSize: theme.typography.fontSize.body,
      lineHeight: '24px',
      wordBreak: 'break-word',
      color: theme.palette.font.primary
    },

    videoDetailsSubContent: {
      fontSize: theme.typography.fontSize.h6,
      lineHeight: '24px',
      margin: '0',
      color: theme.palette.font.primary,
      wordBreak: 'break-word'
    },

    '@media (max-width: 767px)': {
      videoCarousel: {
        flexDirection: 'column',
        gap: '24px'
      },

      videoCarouselContainer: {
        height: 'max-content'
      },

      videoDetails: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: '16px'
      },

      videoDetailsHeading: {
        lineHeight: 'normal'
      },

      videoDetailsSubContent: {
        textAlign: 'center'
      },

      videoTestimonialTitle: {
        lineHeight: 'normal',
        letterSpacing: '-1px',
        textAlign: 'center'
      },

      videoTestimonialHeading: {
        textAlign: 'center'
      }
    }
  };
});

export default useVideoTestimonialStyles;
